import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Theme,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import DropdownInput from "common/components/DropdownInput";
import { useTranslation } from "common/locales";
import { GENERAL_FEED_TYPE } from "model";

const PREFIX = "FeedTypeDropdown";

const classes = {
  formControl: `${PREFIX}-formControl`,
};

const StyledFormControl = styled(FormControl)(
  ({ theme }: { theme: Theme }) => ({
    [`&.${classes.formControl}`]: {
      maxWidth: 400,
      paddingBottom: theme.spacing(2),
    },
  })
);

interface FeedTypeDropdownProps {
  currentFeedType?: GENERAL_FEED_TYPE | undefined;
  disabled: boolean;
  onChange: (e: SelectChangeEvent<GENERAL_FEED_TYPE>) => void;
  feedTypeInputError: boolean;
  label: string;
  name: string;
}

export default function FeedTypeDropdown({
  disabled,
  onChange,
  currentFeedType,
  feedTypeInputError,
  label,
  name,
}: FeedTypeDropdownProps) {
  const { t } = useTranslation();

  return (
    <StyledFormControl
      className={classes.formControl}
      disabled={disabled}
      error={feedTypeInputError}
      fullWidth
    >
      <InputLabel
        id="assignedGroup-select-label"
        variant="standard"
        shrink={true}
        error={feedTypeInputError}
        required
      >
        {t(label)}
      </InputLabel>
      <Select
        labelId="assignedGroup-select-label"
        id="assignedGroup-select"
        value={currentFeedType ?? ("" as GENERAL_FEED_TYPE)}
        onChange={onChangeSelect}
        input={<DropdownInput />}
        error={feedTypeInputError}
        name={name}
      >
        {Object.entries(GENERAL_FEED_TYPE).map(([key, value]) => (
          <MenuItem value={value} key={key}>
            {t(`feedPurchase.feedType.option.${value}`)}
          </MenuItem>
        ))}
      </Select>
    </StyledFormControl>
  );

  function onChangeSelect(e: SelectChangeEvent<GENERAL_FEED_TYPE>) {
    onChange(e);
  }
}
